import { createApiServices } from '@pf126/api-maker'

const baseUrl = window.location.origin.includes('https://labels-tc.merchize.com') ? 'https://labels-tc.merchize.com/api/labels' : 'https://staging-labels-tc.merchize.com/api/labels'
export default createApiServices({
    // baseUrl: window.location.href.match(/^http:\/\/localhost/) ? 'http://localhost:1113' : process.env.NODE_ENV === 'production' ? '/api/labels' : process.env.REACT_APP_API_URL
    baseUrl
})
